import { render, staticRenderFns } from "./BoneProperties.vue?vue&type=template&id=507b0a1a&scoped=true"
import script from "./BoneProperties.vue?vue&type=script&lang=js"
export * from "./BoneProperties.vue?vue&type=script&lang=js"
import style0 from "./BoneProperties.vue?vue&type=style&index=0&id=507b0a1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507b0a1a",
  null
  
)

export default component.exports